module.exports = __webpack_public_path__ + "static/media/front.b2798092.jpg";